import React from 'react'
import './ImageUser.scss'

const ImageUser = ({src}) => {
  return (
    <img className='b-imguser' src={src} alt='' />
  )
}

export default ImageUser